import { Spinner } from '@/modules/common/components/icons';

export const LoadingSpinner = ({ className }: { className?: string }) => {
  return <Spinner className={`animate-spin duration-1000 ease-linear ${className}`} />;
};
